const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: gray;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 15,
  height: 15
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Component_24_4",
  "data-name": "Component 24 \\u2013 4",
  className: "cls-2",
  transform: "translate(15 15) rotate(180)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  className: "cls-3",
  d: "M7.471,0,6.112,1.358,11.254,6.5H0v1.94H11.254L6.112,13.583l1.358,1.358,7.471-7.471Z"
}));
function SvgPaginationArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationArrowLeft);
export default __webpack_public_path__ + "static/media/pagination-arrow-left.b90a859327182418d8ec5fe5e1cc8b09.svg";
export { ForwardRef as ReactComponent };